// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown__d30 {
  display: inline-block;
  overflow: hidden;
  width: 100%;
  word-break: break-word;
  line-height: var(--ring-line-height);
}

.markdown__d30 p:not(:first-child),
.markdown__d30 blockquote:not(:first-child),
.markdown__d30 pre:not(:first-child) {
  margin-top: 10px;
}

.markdown__d30 li {
  margin-top: 10px;
}

.markdown__d30 li:not(:first-child),
.markdown__d30 p:not(:first-child),
.markdown__d30 blockquote:not(:first-child),
.markdown__d30 pre:not(:first-child) {
  margin-top: 10px;
}

.markdown__d30 hr {
  margin: 10px 0;

  border: none;
  border-bottom: 1px solid var(--ring-line-color);
}

.markdown__d30 blockquote {
  padding: 0 0 0 calc(2 * var(--ring-unit));

  color: var(--ring-secondary-color);
  box-shadow: inset 2px 0 0 var(--ring-line-color);

  font-size: 12px;
  line-height: 18px;
}

.markdown__d30 ul {
  padding: 0 0 0 calc(2 * var(--ring-unit));
}

.markdown__d30 ol {
  padding: 0;

  list-style-position: inside;
  font-variant-numeric: tabular-nums;
}

.markdown__d30 ul {
  list-style-type: none;
}

.markdown__d30 h1 {
  font-size: 160%;
  margin: calc(var(--ring-unit) * 3) 0 calc(var(--ring-unit) * 2) 0;
}

.markdown__d30 h2 {
  font-size: 150%;
  margin: calc(var(--ring-unit) * 3) 0 calc(var(--ring-unit) * 2) 0;
}

.markdown__d30 h3 {
  font-size: 140%;
  margin: calc(var(--ring-unit) * 2.5) 0 calc(var(--ring-unit) * 1.5) 0;
}

.markdown__d30 h4 {
  font-size: 125%;
  margin: calc(var(--ring-unit) * 2.5) 0 calc(var(--ring-unit) * 1.5) 0;
}

.markdown__d30 h5 {
  font-size: 110%;
  margin: calc(var(--ring-unit) * 2) 0 var(--ring-unit) 0;
}

.markdown__d30 h6 {
  font-size: 100%;
  font-weight: bold;
  margin: var(--ring-unit) 0;
}

.markdown__d30 h1,
.markdown__d30 h2,
.markdown__d30 h3,
.markdown__d30 h4,
.markdown__d30 h5,
.markdown__d30 h6 {
  line-height: var(--ring-line-height-taller);
}

.markdown__d30 a {
  cursor: pointer;
  transition: color var(--ring-fast-ease);
  text-decoration: none;
  color: var(--ring-link-color);
}

.markdown__d30 a:hover {
  transition: color var(--ring-fast-ease);
  text-decoration: none;
  text-decoration-line: underline;
  text-underline-offset: calc(var(--ring-unit) / 2);
  text-decoration-thickness: 1px;
  text-decoration-color: var(--ring-link-hover-color);
  color: var(--ring-link-hover-color);
}

@media (min-resolution: 2dppx) {
  .markdown__d30 a:hover {
    text-decoration-thickness: 0.5px;
  }
}

.markdown__d30 table {
  border-spacing: 0;
  border-collapse: collapse;
  margin: 10px 0;
}

.markdown__d30 table tr td,
.markdown__d30 table tr th {
  padding: var(--ring-unit) calc(2 * var(--ring-unit));
  border: 1px solid var(--ring-borders-color);
}

.markdown__d30 table tr th {
  background-color: var(--ring-hover-background-color);
}
`, "",{"version":3,"sources":["webpack://./src/common/markdown/markdown.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;;EAEzC,kCAAkC;EAClC,gDAAgD;;EAEhD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;;EAEV,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,eAAe;EACf,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;;;;;EAME,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,+BAA+B;EAC/B,iDAAiD;EACjD,8BAA8B;EAC9B,mDAAmD;EACnD,mCAAmC;AACrC;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,oDAAoD;AACtD","sourcesContent":[".markdown {\n  display: inline-block;\n  overflow: hidden;\n  width: 100%;\n  word-break: break-word;\n  line-height: var(--ring-line-height);\n}\n\n.markdown p:not(:first-child),\n.markdown blockquote:not(:first-child),\n.markdown pre:not(:first-child) {\n  margin-top: 10px;\n}\n\n.markdown li {\n  margin-top: 10px;\n}\n\n.markdown li:not(:first-child),\n.markdown p:not(:first-child),\n.markdown blockquote:not(:first-child),\n.markdown pre:not(:first-child) {\n  margin-top: 10px;\n}\n\n.markdown hr {\n  margin: 10px 0;\n\n  border: none;\n  border-bottom: 1px solid var(--ring-line-color);\n}\n\n.markdown blockquote {\n  padding: 0 0 0 calc(2 * var(--ring-unit));\n\n  color: var(--ring-secondary-color);\n  box-shadow: inset 2px 0 0 var(--ring-line-color);\n\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.markdown ul {\n  padding: 0 0 0 calc(2 * var(--ring-unit));\n}\n\n.markdown ol {\n  padding: 0;\n\n  list-style-position: inside;\n  font-variant-numeric: tabular-nums;\n}\n\n.markdown ul {\n  list-style-type: none;\n}\n\n.markdown h1 {\n  font-size: 160%;\n  margin: calc(var(--ring-unit) * 3) 0 calc(var(--ring-unit) * 2) 0;\n}\n\n.markdown h2 {\n  font-size: 150%;\n  margin: calc(var(--ring-unit) * 3) 0 calc(var(--ring-unit) * 2) 0;\n}\n\n.markdown h3 {\n  font-size: 140%;\n  margin: calc(var(--ring-unit) * 2.5) 0 calc(var(--ring-unit) * 1.5) 0;\n}\n\n.markdown h4 {\n  font-size: 125%;\n  margin: calc(var(--ring-unit) * 2.5) 0 calc(var(--ring-unit) * 1.5) 0;\n}\n\n.markdown h5 {\n  font-size: 110%;\n  margin: calc(var(--ring-unit) * 2) 0 var(--ring-unit) 0;\n}\n\n.markdown h6 {\n  font-size: 100%;\n  font-weight: bold;\n  margin: var(--ring-unit) 0;\n}\n\n.markdown h1,\n.markdown h2,\n.markdown h3,\n.markdown h4,\n.markdown h5,\n.markdown h6 {\n  line-height: var(--ring-line-height-taller);\n}\n\n.markdown a {\n  cursor: pointer;\n  transition: color var(--ring-fast-ease);\n  text-decoration: none;\n  color: var(--ring-link-color);\n}\n\n.markdown a:hover {\n  transition: color var(--ring-fast-ease);\n  text-decoration: none;\n  text-decoration-line: underline;\n  text-underline-offset: calc(var(--ring-unit) / 2);\n  text-decoration-thickness: 1px;\n  text-decoration-color: var(--ring-link-hover-color);\n  color: var(--ring-link-hover-color);\n}\n\n@media (min-resolution: 2dppx) {\n  .markdown a:hover {\n    text-decoration-thickness: 0.5px;\n  }\n}\n\n.markdown table {\n  border-spacing: 0;\n  border-collapse: collapse;\n  margin: 10px 0;\n}\n\n.markdown table tr td,\n.markdown table tr th {\n  padding: var(--ring-unit) calc(2 * var(--ring-unit));\n  border: 1px solid var(--ring-borders-color);\n}\n\n.markdown table tr th {\n  background-color: var(--ring-hover-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markdown": `markdown__d30`
};
export default ___CSS_LOADER_EXPORT___;
